module.exports = __webpack_public_path__ + "img/ts10.a7ca601a.png";